module.exports = __webpack_public_path__ + "static/media/camera-selected.d23ca1e1.svg";